import { Modal } from "react-bootstrap";
import checkIcon from "../../../images/check-solid.png";

export default function ConfirmationVoucherAddedToCartPage(props) {
    return (
        <>
            <Modal.Body>
                <div className="text-center pt-5 pb-3">Voucher added to cart</div>
                <div className="d-flex justify-content-center pb-4">
                    <div className="bg-success rounded-pill d-flex justify-content-center align-items-center" style={{width: "40px", height: "40px"}}><img src={checkIcon} alt="Success Check Icon" style={{width: "22px"}}></img></div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <div className="col-12 d-flex justify-content-center mx-auto">
                    <button type="button" className="btn btn-dark rounded-pill px-5" onClick={props.handleClickCloseLoyaltyModal} >
                        Ok
                    </button>
                </div>
            </Modal.Footer>
        </>
    )
}